import script from "./FitxasEtnobotanicasEnkarterri.vue?vue&type=script&setup=true&lang=js"
export * from "./FitxasEtnobotanicasEnkarterri.vue?vue&type=script&setup=true&lang=js"

import "./FitxasEtnobotanicasEnkarterri.vue?vue&type=style&index=0&id=76b10720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b10720"]])

export default __exports__